import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getFeatureToggle } from '@capital-access/common/feature-toggle';
import { PageSize } from '../models/report-page.model';
import {
  TEMPLATE_DESIGNER_FEATURE_KEY,
  TEMPLATE_LIBRARY_FEATURE_KEY
} from '../models/report-section-configuration.model';
import { ReportType } from '../models/report-type.enum';
import { TemplateDesignerState } from '../models/template-designer-state.model';
import { TemplateLibraryState } from '../models/template-library-state.model';

export const templateDesignerSelector = createFeatureSelector<TemplateDesignerState>(TEMPLATE_DESIGNER_FEATURE_KEY);
export const templateLibraryFeatureSelector = createFeatureSelector<TemplateLibraryState>(TEMPLATE_LIBRARY_FEATURE_KEY);

export const getSelectedListItemForTemplateExport = createSelector(
  templateDesignerSelector,
  state => state.export.selectedList.filter(item => item.isSelected)[0]
);

export const getSelectedListForTemplateExportInclusion = createSelector(
  templateDesignerSelector,
  state => state.export.selectedList
);

export const getOwnershipAnalysisSelectedList = createSelector(
  templateDesignerSelector,
  state => state.export.ownershipAnalysisSelectedList
);

export const getPeerOwnershipSelectedList = createSelector(
  templateDesignerSelector,
  state => state.export.peerOwnershipSelectedList
);

export const getCurrentReportTemplatePageSize = createSelector(
  templateDesignerSelector,
  (state: TemplateDesignerState) => {
    const settings = state.reportTemplate?.settings ? JSON.parse(state.reportTemplate.settings) : {};
    return settings.pageSize;
  }
);

export const getReportType = createSelector(
  templateLibraryFeatureSelector,
  getFeatureToggle('configurable-itinerary-report-ISD-15521'),
  (state: TemplateLibraryState, isItineraryEnabled: boolean): ReportType | null => {
    const reportType = state.selectedReportType || (state.selectedTemplateForPreview?.reportType as ReportType | null);

    if (reportType === ReportType.Itinerary && !isItineraryEnabled) {
      return null;
    }
    return reportType;
  }
);

export const getSelectedTemplatePageSize = createSelector(
  templateLibraryFeatureSelector,
  getReportType,
  (state: TemplateLibraryState, reportType: ReportType | null) => {
    const pageSize = state.templatePageSize;
    if (reportType === ReportType.Itinerary) {
      if (pageSize === 'us-letter') {
        return 'us-letter-itinerary' as const;
      } else if (pageSize === 'a4') {
        return 'a4-itinerary' as const;
      }
    }
    // For non-itinerary reports, strip itinerary suffix if present
    if (pageSize.endsWith('-itinerary')) {
      return (pageSize.replace('-itinerary', '') as PageSize) || 'us-letter';
    }
    return pageSize;
  }
);

export const getZoomValue = createSelector(
  templateDesignerSelector,
  (state: TemplateDesignerState) => state.zoomState.zoom
);

export const getItineraryComments = createSelector(
  templateDesignerSelector,
  state => state.export.exportItineraryComments
);
